import script from "./results_history_control.vue?vue&type=script&setup=true&lang=js"
export * from "./results_history_control.vue?vue&type=script&setup=true&lang=js"

import "./results_history_control.vue?vue&type=style&index=0&id=a4ac2c30&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4ac2c30"]])

export default __exports__